export default {
    jira_details_title: "Details",
    jira_details_task: "Task",
    jira_details_summary: "Summary",
    jira_details_start: "Start",
    jira_details_end: "End",
    jira_details_rejections: "Rejections",
    jira_details_manual_rejections: "Manual Rejections",
    jira_details_date: "Date",
    jira_details_no_tasks: "No Tasks",
    jira_details_no_rejected_tasks: "No Rejected Tasks",
    jira_details_no_holidays: "No Holidays",
    jira_details_holidays: "Holidays",
    jira_details_story_points: "Story Points",
    jira_details_responsible: "Responsible",
    jira_details_issue_type: "Issue Type",
    jira_details_no_responsible_tasks: "No Responsible Tasks",
}